import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Flex as ButtonGroupWrapper } from 'ui/buttonGroupV2/ButtonGroup.styles';
import { pxToRem } from 'utils/convert';
import { actionButtonGroupRadii } from '../QueryLayout/QueryLayout.styles';

export const ConditionLayoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: inherit;
  min-width: 0;
  width: 100%;
  column-gap: ${spacing.half};
`;

export const ConditionLayoutSubWrapper = styled.div`
  column-gap: ${spacing.half};
  display: flex;
  flex-direction: row;

  :nth-child(2) {
    /* Don't resize the delete button for secondary conditions */
    flex: 0 0 0;
  }

  > *:nth-child(-n + 2) {
    /* Don't resize the FieldSelect or ComparatorSelect */
    flex: 0 0 auto;
  }

  > *:nth-child(4) {
    /* Don't resize the CastTypeSelect */
    flex: 0 0 auto;
  }
`;

export const ConditionActionButtons = styled(ButtonGroupWrapper)`
  opacity: 0;
  flex: 0 0 auto;
  > span > button {
    border-width: ${pxToRem(1.5)};
    border-style: solid;
    border-color: ${colors.borderPrimary};
  };
  ${actionButtonGroupRadii('> span')}
`;
